import { END_ICON_PATH, END_ICON_VIEWBOX } from '../constants/moTravel.constants';

interface MoEndIconProps {
  className?: string;
}

export function MoEndIcon({ className }: MoEndIconProps) {
  return (
    <svg viewBox={END_ICON_VIEWBOX} fill="currentColor" className={className} aria-hidden>
      <path d={END_ICON_PATH} />
    </svg>
  );
}
